import { mergeArrays } from '../../mergeFunctions';
import { testIf } from '../validationFunctions';
import { successState, formatResults } from '../validationHelpers';

export const validateAddressSecret = ({ data, setNotificationText }) => {
  const emptyRes = testIf('empty')(data, ['name', 'addressOne', 'postalCode', 'country']);
  const lengthRes = testIf('shorterThan')(data, ['name'], 50);

  const testResults = mergeArrays([emptyRes, lengthRes]);
  if (testResults.length === 0) return successState(setNotificationText);
  setNotificationText(formatResults(testResults));
};
